import { useMutation } from '@tanstack/react-query'

import { updatePaymentRequestEvidence } from '@src/api'
import { DefaultApiUpdatePaymentRequestEvidenceRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdatePaymentRequestEvidence = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdatePaymentRequestEvidenceRequest) =>
      updatePaymentRequestEvidence(axiosInstance, params),
  })
}
